import Base from './Base';
import ContainerMixin from './ContainerMixin';
/**
 * Container is a base class used for abstracting common functionality
 */
export default class Container extends ContainerMixin(Base) {

    constructor() {
        super();
        this.setupContainer();
    }
}


// WEBPACK FOOTER //
// /data/php7/vendor/etouches/ecore/es6/base/Container.es6